// Module
var code = "<div style=\"padding-left:100px;padding-top:100px\"> <button ng-click=\"gcal.addToCalendar();\">Add to Google Calendar</button> </div>";
// Exports
module.exports = code;